import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REGIONS } from 'constants/Regions';
import SessionStore from '../../stores/SessionStore';
import VerticalNav from '../v2/navs/VerticalNav';
import LayoutWithSidebar from '../v2/LayoutWithSidebar';
// Pages Import
import EDIResender from './tools/EDIResender';
import PODDownloader from './tools/PODDownloader';
import BulkAdjustments from './shipments/BulkAdjustments';
import ReferenceNumbersUpload from './shipments/ReferenceNumbersUpload';
import BulkShipmentCancellation from './tools/BulkShipmentCancellation';
import ExportDocuments from './tools/ExportDocuments';
import BulkShipmentRerate from './tools/BulkShipmentRerate';
import BulkEvaluateBillingStatus from './tools/BulkEvaluateBillingStatus';
const userDoesNotHaveShipperOrCarrierRole = () => {
    return !SessionStore.isShipper() && !SessionStore.isCarrier();
};
const getToolsData = () => {
    return [
        {
            title: 'BULK_BASE_COST_ADJUSTMENT',
            key: 'bulk-base-cost-adjustment',
            show: userDoesNotHaveShipperOrCarrierRole(),
        },
        {
            title: 'POD_DOWNLOADER',
            key: 'pod-downloader',
            show: SessionStore.isAdmin(),
        },
        {
            title: 'EDI_RESENDER',
            key: 'edi-resender',
            show: (SessionStore.isGodAdmin() ||
                SessionStore.hasIntegrationManagerRole()) &&
                REGION_CODE === REGIONS.US,
        },
        {
            title: 'REFERENCE_NUMBER_ADDITION',
            key: 'reference-number-addition',
            show: true,
        },
        {
            title: 'BULK_CANCEL_SHIPMENT',
            key: 'bulk-cancel-shipment',
            show: userDoesNotHaveShipperOrCarrierRole(),
        },
        {
            title: 'EXPORT_DOCUMENTS',
            key: 'export-documents',
            show: true,
        },
        {
            title: 'BULK_RERATE_SHIPMENT',
            key: 'bulk-rerate-shipment',
            show: userDoesNotHaveShipperOrCarrierRole(),
        },
        {
            title: 'Bulk Evaluate Shipments',
            key: 'bulk-override-billing-status',
            show: true,
        },
    ];
};
const ToolsNav = ({ title, pageName, currentPage, setCurrentPage, show }) => {
    const isActive = pageName === currentPage;
    if (!show) {
        return null;
    }
    return (React.createElement(VerticalNav.NavItem, { key: pageName, id: pageName, onClick: () => setCurrentPage(pageName), active: isActive, title: title }, title));
};
const ToolsContent = ({ activePage }) => {
    switch (activePage) {
        case 'bulk-base-cost-adjustment':
            return React.createElement(BulkAdjustments, null);
        case 'edi-resender':
            return React.createElement(EDIResender, null);
        case 'pod-downloader':
            return React.createElement(PODDownloader, null);
        case 'reference-number-addition':
            return React.createElement(ReferenceNumbersUpload, null);
        case 'bulk-cancel-shipment':
            return React.createElement(BulkShipmentCancellation, null);
        case 'export-documents':
            return React.createElement(ExportDocuments, null);
        case 'bulk-rerate-shipment':
            return React.createElement(BulkShipmentRerate, null);
        case 'bulk-override-billing-status':
            return React.createElement(BulkEvaluateBillingStatus, null);
        default:
            return React.createElement(BulkAdjustments, null);
    }
};
const getBreadcrumbs = (t, pageSlug) => ({
    pages: [
        {
            name: t('TOOLS'),
            href: '/tools',
            current: true,
        },
        {
            name: t(pageSlug),
            current: true,
        },
    ],
});
const getSideBar = (t, page, setPage) => () => (React.createElement(VerticalNav, null, getToolsData().map(({ title, key: pageName, show }) => {
    return (React.createElement(ToolsNav, { title: t(title), pageName: pageName, show: show, currentPage: page, setCurrentPage: setPage }));
})));
const ToolsPage = () => {
    var _a;
    const [page, setPage] = useState('bulk-base-cost-adjustment');
    const pageSlug = (_a = getToolsData().filter((data) => data.key === page)[0]) === null || _a === void 0 ? void 0 : _a.title;
    const { t } = useTranslation();
    return (React.createElement(LayoutWithSidebar, { breadcrumbs: getBreadcrumbs(t, pageSlug), sidebar: getSideBar(t, page, setPage), className: "py-10" },
        React.createElement("div", { "data-testid": "toolsContent" },
            React.createElement(ToolsContent, { activePage: page }))));
};
export default ToolsPage;
